<div
  class="first-access-form mx-auto d-flex align-items-md-center justify-content-start pt-0 pt-md-3 pb-5 px-3 px-md-5">
  <div class="form-container w-100">
    <div class="logo-header d-flex align-items-center my-md-4">
      <img
        src="assets/images/logo_legatus_fundo_claro_1.png"
        alt="Legatus Growth Partner"
        title="Legatus Growth Partner"
        class="img-fluid" />
    </div>
    <div class="first-access-form__header my-3">
      <h2 class="first-access-form__header__title my-4">
        <span class="color__dark cursor-pointer me-3" (click)="handleFormMode('login')">
          <fa-icon [icon]="faArrowLeftLong" size="xs"></fa-icon>
        </span>
        {{ tk.Auth.FirstAccessLabel | t }} aaaaa
      </h2>
      <p class="first-access-form__header__subtitle mb-4">
        {{ tk.Auth.RecoverPasswordInstructions | t }}
      </p>
    </div>
    <div class="form-body">
      <form [formGroup]="firstAccessForm" (ngSubmit)="onSubmit()" appAutoFormGroup>
        <div class="form-group">
          <app-input
            [type]="'email'"
            [formGroup]="firstAccessForm"
            [controlName]="props.email"
            [placeholder]="tk.General.Insert | t"
            [label]="tk.Auth.FieldEmail | t"
            [required]="true"
            [disabled]="false"
            [error]="true"
            (sendInputValue)="handleFormValue($event)"></app-input>
        </div>
        <div class="form-group">
          <app-button
            [type]="'submit'"
            [id]="'submit'"
            [label]="isLoading ? 'loadingMessage' : (tk.Auth.ToDefine | t)"
            [disabled]="isEmailInvalidOrEmpty()"></app-button>
        </div>
      </form>
    </div>
  </div>
</div>
